"use client";

import { useEffect, useRef } from "react";

export default function ArticleViewTracker({
  documentId,
}: {
  documentId: number;
}) {
  const tracked = useRef<number | null>(null);

  useEffect(() => {
    if (tracked.current === documentId) {
      return;
    }
    tracked.current = documentId;

    const endpoint = `/api/articles/view?id=${documentId}`;
    if (!navigator.sendBeacon?.(endpoint)) {
      fetch(endpoint, { method: "POST", keepalive: true }).catch(() => {});
    }
  }, [documentId]);

  return null;
}
